module.exports = __webpack_public_path__ + "static/img/glucose.5b2556c1.jpg";